import React from "react";
import styles from "./CreatedOnComponent.module.scss";

const CreatedOnComponent = ({ date }) => {
  return (
    <div className={styles.createdOn_card}>
      <p>Created on - {date}</p>
    </div>
  );
};

export default CreatedOnComponent;
